import styled from 'styled-components'
import tw from 'twin.macro'

export const Input = styled.input`
  ${tw`bg-gray-200 px-4 py-2 w-full outline-none`}
  ::placeholder {
    ${tw`tracking-tight`}
  }
`

export const TextArea = styled.input`
  ${tw`w-full focus:outline-none rounded-none px-4 py-2 bg-gray-200`}
  min-height: 126px;
  ::-webkit-input-placeholder {
    position: relative !important;
    transform: translateY(-220%) !important;
  }
  input::-moz-placeholder {
    vertical-align: top;
  }
  input::-ms-input-placeholder {
    vertical-align: top;
  }
`
